import useIcon from "./useIcon";
import { makeStyles } from "@material-ui/core";

const styles = (theme) => ({
  balanceImage: {
    marginLeft: theme.spacing(1),
  },
  balanceImageNegative: {
    marginLeft: `-${theme.spacing(1)}px`,
  },
});

const useStyles = makeStyles(styles);

const useFormat = () => {
  const [iconImage] = useIcon();

  const classes = useStyles();

  // Turns the account's balance into something nice and readable
  const formatBalance = (balance, symbol) => {
    return (
      <>
        {balance ? parseFloat(balance).toPrecision(8) : "0.00"}{" "}
        {typeof symbol === "string" ? (
          <>
            <img
              className={classes.balanceImage}
              src={iconImage(symbol)}
              alt={symbol}
            />
          </>
        ) : (
          <>
            {typeof symbol[0] !== "string" ? (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[0][0])}
                  alt={symbol[0][0]}
                />
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[0][1])}
                  alt={symbol[0][1]}
                />
              </>
            ) : (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[0])}
                  alt={symbol[0]}
                />
              </>
            )}

            {typeof symbol[1] !== "string" ? (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[1][0])}
                  alt={symbol[1][0]}
                />
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[1][1])}
                  alt={symbol[1][1]}
                />
              </>
            ) : (
              <>
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[1])}
                  alt={symbol[1]}
                />
              </>
            )}
          </>
        )}
      </>
    );
  };

  // Turns the coin's reserves into something nice and readable
  const formatReserve = (reserve, symbol) => {
    return (
      <>
        {reserve || "0.00"}{" "}
        {typeof symbol === "string" ? (
          <>
            <img
              className={classes.balanceImage}
              src={iconImage(symbol)}
              alt={symbol}
            />
          </>
        ) : (
          <>
            {typeof symbol[0] !== "string" ? (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[0][0])}
                  alt={symbol[0][0]}
                />
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[0][1])}
                  alt={symbol[0][1]}
                />
              </>
            ) : (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[0])}
                  alt={symbol[0]}
                />
              </>
            )}

            {typeof symbol[1] !== "string" ? (
              <>
                <img
                  className={classes.balanceImage}
                  src={iconImage(symbol[1][0])}
                  alt={symbol[1][0]}
                />
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[1][1])}
                  alt={symbol[1][1]}
                />
              </>
            ) : (
              <>
                <img
                  className={classes.balanceImageNegative}
                  src={iconImage(symbol[1])}
                  alt={symbol[1]}
                />
              </>
            )}
          </>
        )}
      </>
    );
  };

  return [formatBalance, formatReserve];
};

export default useFormat;
